<nz-modal
  [(nzVisible)]="isVisibleBanner"
  nzCentered
  [nzFooter]="null"
  [nzMaskClosable]="false"
  [nzClosable]="nextStep ? true : false"
  [nzWidth]="580"
  (nzOnCancel)="handleCancel()"
>
  <ng-container *nzModalContent>
    <div *ngIf="!nextStep" class="flex flex-col justify-center items-center gap-2">
      <img src="https://storage.googleapis.com/komerce/rajaongkir/rocket-bg-orange.svg" alt="start tour" />
      <span class="font-bold text-primary text-center w-full title">Selamat Datang di Dashboard Collaborator! 🎉</span>
      <p class="text-center text-muted">Kelola integrasi API pengiriman dan pembayaran dengan lebih mudah. Mulai tur singkat ini untuk memahami fungsi dari setiap fitur di Dashboard Collaborator Anda.</p>
      <div class="flex flex-col justify-center items-center gap-2 w-full">
        <button nz-button nzType="primary" class="w-full" (click)="handleStart()">Mulai Tour</button>
        <a class="cursor-pointer text-primary" (click)="handleCancel()">Nanti Saja</a>
      </div>
    </div>

    <div *ngIf="nextStep" class="flex flex-col justify-center items-center gap-2">
      <img src="https://storage.googleapis.com/komerce/rajaongkir/setting-bg-orange.svg" alt="start tour" />
      <span class="font-bold text-primary text-center w-full title">Pilih Layanan untuk Memulai Tour</span>
      <p class="text-center text-muted">RajaOngkir memiliki berbagai layanan untuk mempercepat bisnismu. Pilih layanan yang ingin Anda integrasikan lebih dulu, dan kami akan memandu Anda langkah demi langkah.</p>
      <div class="grid grid-cols-2 items-stretch gap-2 w-full">
        <nz-card nzHoverable *ngFor="let product of productList" class="cursor-pointer h-full" (click)="handleProductClick(product)">
          <div class="flex items-start gap-2 px-2 py-3 h-full">
            <div class="flex items-start justify-center w-12 h-12 shrink-0">
              <img [src]="product.icon" alt="product icon" />
            </div>
            <div class="flex flex-col items-start justify-center h-full">
              <span class="font-medium">{{ product.name }}</span>
              <span class="text-muted text-xs">{{ product.desc }}</span>
            </div>
          </div>
        </nz-card>
      </div>
    </div>
  </ng-container>
</nz-modal>

